import React, { useContext, useState } from 'react';
import { Button, Form, Image, Spinner } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import Logo from '../assets/Logo.png';
import { AuthContext } from '../context/AuthContext';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';

const validationSchema = Yup.object({
    username: Yup.string().max(15, 'Must be 15 characters or less').required('Required'),
    password: Yup.string().required('Required'),
});

export const Login = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { logIn, loggedUser, mainPage } = useContext(AuthContext);
    const [loginFailed, setLoginFailed] = useState <number|null>(null);
    const [loading, setLoading] = useState(false);

    const onSubmit = async (username: string, password: string) => {
        setLoading(true);
        const isLoggedIn = await logIn(username, password);
        setLoading(false);

        if (isLoggedIn === 401 || isLoggedIn === 423) setLoginFailed(isLoggedIn);
    };

    if (loggedUser && mainPage) return <Navigate to={mainPage} replace />;
    if (loggedUser) return <Spinner animation='border' variant='primary' />;

    return (
        <div className='d-flex flex-column justify-content-center  align-items-center vh-100 '>
            <div className='d-flex flex-column align-items-center px-3'>
                <Image className='w-75 pb-4' src={Logo}></Image>
                <Formik
                    validationSchema={validationSchema}
                    onSubmit={(values) => onSubmit(values.username, values.password)}
                    initialValues={{ username: '', password: '' }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, touched, errors }) => (
                        <Form
                            className='d-flex flex-column align-items-center p-4 border rounded w-100 shadow-lg'
                            noValidate
                            onSubmit={(e) => {
                                handleSubmit(e);
                            }}
                        >
                            <Form.Group
                                className=' d-flex flex-column mb-3 align-items-start w-100 '
                                controlId='formBasicEmail'
                            >
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder='Enter username'
                                    name='username'
                                    value={values.username}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.username}
                                />
                                <Form.Control.Feedback type='invalid'>{errors.username}</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group
                                className='d-flex flex-column mb-4 align-items-start w-100'
                                controlId='formBasicPassword'
                            >
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type='password'
                                    placeholder='Enter password'
                                    name='password'
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.password && !!errors.password}
                                />
                                <Form.Control.Feedback type='invalid'>{errors.password}</Form.Control.Feedback>
                            </Form.Group>
                            <Button variant='primary' type='submit' className='w-50 color-main'>
                                {loading ? <Spinner animation='border' variant='light' size='sm' /> : 'Login'}
                            </Button>
                            {loginFailed && <p className='pb-1 mt-2 mb-0 text-danger'>{t(loginFailed==401?"wrongCredentials":"Out of work hours")}</p>}
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};
